import { ServiceResultWith } from 'schemas/ServiceResultSchema'
import { AnnotatedMetricResult } from 'schemas/AnnotatedMetricResultSchema'
import { MetricTimeUnitStrings } from 'enums/MetricTimeUnit'
import { MetricSeries as MetricSeriesType } from 'schemas/MetricSeriesSchema'
import { MetricSeriesStrings } from 'enums/MetricSeries'
import InsightViewOption, { InsightViewOptionStrings } from 'enums/InsightViewOption'
import MeasureType from 'enums/MeasureType'
import { ReturnStatusStrings } from 'enums/ReturnStatus'

const retrieveDatasetByTimeUnit = (
  data: ServiceResultWith<AnnotatedMetricResult>,
  timeUnit: MetricTimeUnitStrings
) =>
  data?.results?.[0].data.metrics?.find((currentMetric) => currentMetric.timeUnit === timeUnit)
    ?.dataset || []

const getSeriesToValues = (dataset: MetricSeriesType[]) =>
  dataset.reduce(
    (accumulator, current) => ({
      ...accumulator,
      [current.seriesName!]: current.set as number[]
    }),
    {} as Record<MetricSeriesStrings, number[]>
  )

const getSeriesToStatus = (dataset: MetricSeriesType[]) =>
  dataset.reduce(
    (accumulator, current) => ({
      ...accumulator,
      [current.seriesName!]: current.status as ReturnStatusStrings
    }),
    {} as Record<MetricSeriesStrings, ReturnStatusStrings>
  )

export const getSeriesToValuesByTimeUnit = (timeUnit: MetricTimeUnitStrings) => (
  data: ServiceResultWith<AnnotatedMetricResult>
) => getSeriesToValues(retrieveDatasetByTimeUnit(data, timeUnit))

export const getSeriesToStatusByTimeUnit = (timeUnit: MetricTimeUnitStrings) => (
  data: ServiceResultWith<AnnotatedMetricResult>
) => getSeriesToStatus(retrieveDatasetByTimeUnit(data, timeUnit))

export const getMainMeasure = (viewOption: InsightViewOptionStrings, isAudienceQuery?: boolean) => {
  if (isAudienceQuery) {
    return MeasureType.UNIQUE_AUTHORS
  }
  return viewOption === InsightViewOption.POSTS ? MeasureType.POSTS : MeasureType.MENTIONS
}
